import React from 'react';
import TodoList from './CeckOutDetail/TodoList';
import './CheckOut.css'

const CheckOut = () => {
     return (
          <div className='check'>
               <h1 className='text-center text-primary'>TO-OD LIST HERE</h1>
               <div className='h-100  rounded my-5 d-flex align-item-center justify-content-center'>
                    <TodoList></TodoList>
               </div>

          </div>
     );
};

export default CheckOut;